var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C12.4183 7.73107e-07 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 7.73132e-07 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4Z",
    fill: "#7940E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/Subtract.757ee54a40e7a8fe6c45c4318ffe8e66.svg";
export { ForwardRef as ReactComponent };